import { render } from "./HomeBody.vue?vue&type=template&id=56591d66&scoped=true"
import script from "./HomeBody.vue?vue&type=script&lang=js"
export * from "./HomeBody.vue?vue&type=script&lang=js"

import "./HomeBody.vue?vue&type=style&index=0&id=56591d66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56591d66"]])

export default __exports__